export const flattenStateValue = (stateValue: any, prefix = ''): string => {
  if (typeof stateValue === 'string') {
    return prefix ? `${prefix}.${stateValue}` : stateValue
  }
  return Object.keys(stateValue)
    .map((key) => flattenStateValue(stateValue[key], prefix ? `${prefix}.${key}` : key))
    .join('.')
}
